import React, { CSSProperties } from "react";
import { Image } from "antd-mobile";

interface IProps {
  label: string;
  icon: string;
  onPress?: () => void;
}

const Item: React.FC<IProps> = React.memo((props) => {
  const { label, icon, onPress } = props;

  return (
    <div style={container} onClick={onPress}>
      <div style={iconWrap}>
        <Image style={iconStyles} src={icon} />
      </div>
      <div style={labelSttyles}>{label}</div>
    </div>
  );
});

const container: CSSProperties = {
  alignItems: "center",
  justifySelf: "center",
  paddingTop: 12,
  paddingBottom: 12,
};

const iconWrap: CSSProperties = {
  width: 48,
  height: 48,
  borderRadius: 24,
  marginBottom: 12,
};

const iconStyles: CSSProperties = {
  width: 48,
  height: 48,
  borderRadius: 24,
};

const labelSttyles: CSSProperties = {
  paddingTop: 4,
  paddingBottom: 4,
  color: "#cbd6e2",
};

export default Item;
